<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 16 16"
  >
    <g id="Menu" transform="translate(-35 -37)">
      <rect
        id="Rectangle_175"
        data-name="Rectangle 175"
        width="16"
        height="16"
        transform="translate(35 37)"
        fill="none"
      />
      <path
        id="Union_4"
        data-name="Union 4"
        d="M0,14V12H8v2ZM0,8V6H16V8ZM0,2V0H16V2Z"
        transform="translate(35 38)"
        fill="#f0324c"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-4'
    },
    height: {
      type: String,
      default: 'h-4'
    }
  }
}
</script>
